module.exports = function() {
  return new Worker(__webpack_public_path__ + "fc9d304aef02520516b3.worker.js");
};